<template>
  <div id="userLayout" :class="['user-layout-wrapper', device]">
    <div class="container">
      <div class="top">
        <div class="header">
          <a href="/">
            <!-- <img src="@/assets/images/logo.png" class="logo" alt="logo" /> -->
            <span class="title">{{ projectName }}</span>
          </a>
        </div>
      </div>

      <router-view></router-view>

      <div class="footer">
        <div class="copyright">Copyright &copy; {{ 2022 + newYearMsg}} 优邻云享版权所有</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserLayout',
  data () {
    return {}
  },
  computed: {
    newYearMsg () {
      if (this.$store.state.thisYear === 2022) {
        return ''
      } else {
        return '-' + this.$store.state.thisYear
      }
    }
  },
  mounted () {
    document.body.classList.add('userLayout')
  },
  beforeDestroy () {
    document.body.classList.remove('userLayout')
  }
}
</script>

<style lang="scss" scoped>
  #userLayout.user-layout-wrapper {
    height: 100vh;

    &.mobile {
      .container {
        .main {
          max-width: 368px;
          width: 98%;
        }
      }
    }

    .container {
      width: 100%;
      min-height: 100%;
      background: #f0f2f5 url('~@/assets/images/background.svg') no-repeat 50%;
      background-size: 100%;
      padding: 110px 0 144px;
      position: relative;

      a {
        text-decoration: none;
      }

      .top {
        text-align: center;
        margin-bottom: 40px;

        .header {
          height: 44px;
          line-height: 44px;

          .badge {
            position: absolute;
            display: inline-block;
            line-height: 1;
            vertical-align: middle;
            margin-left: -12px;
            margin-top: -10px;
            opacity: 0.8;
          }

          .logo {
            width: 75px;
            height: 75px;
            vertical-align: top;
            margin-right: 16px;
            border-style: none;
          }

          .title {
            font-size: 33px;
            color: rgba(0, 0, 0, .85);
            font-family: Avenir, 'Helvetica Neue', Arial, Helvetica, sans-serif;
            font-weight: 600;
            position: relative;
            top: 2px;
          }
        }
      }

      .main {
        min-width: 260px;
        width: 368px;
        margin: 0 auto;
      }

      .footer {
        position: absolute;
        width: 100%;
        bottom: 0;
        padding: 0 16px;
        margin: 48px 0 24px;
        text-align: center;

        .copyright {
          color: rgba(0, 0, 0, 0.45);
          font-size: 14px;
        }
      }
    }
  }
</style>
